<template>
  <div>
    <b-modal v-model="modalShow" centered hide-footer>
      <h5 align="center">{{this.$i18n.translate('ModalInfoText') }}</h5>
      <br>
      <br>
      <br>
      <div class="col-md-8 offset-md-2 text-center">
        <button
          type="button"
          class="btn btn-primary btn-lg mr-5"
          @click="modalShow=!modalShow"
        >{{this.$i18n.translate('OK')}}</button>
        <a
          href="https://petrokemija.hr/Portals/0/Letak_Uputa%20o%20uzimanju%20uzorka%20tla_kor2.pdf"
          class="btn btn-primary-ePetro btn-lg link-color-petro"
          target="_blank"
          rel="noopener"
          role="button"
          aria-pressed="true"
        >{{this.$i18n.translate('LearnMore')}}</a>
      </div>
      <br>
      <br>
    </b-modal>
    <div
      class="alert-eParameters second-container-ePetro"
      role="alert"
    >
      <div class="form-row">
        <div class="form-group col-md-6">
          <label
            for="ePetroBtn"
            class="col-form-label-sm font-weight-bold"
            :class="DisableButtonsLabel ? 'displayBtn' :''"
          >{{LabelAdditional}}. {{this.$i18n.translate('ChemicalSoilAnalysisQuestion') }}</label>
        </div>
      </div>
      <div class="col-md-8 offset-md-2 text-center">
        <button
          type="button"
          @click="ActiveDropDownPlugin = true"
          @click.reset="resetAdditionalParametersValueYes"
          class="btn btn-ePetro mr-5"
          id="ePetroBtn_yes"
          :class="DisableButtonsLabel ? 'displayBtn' :''"
        >{{this.$i18n.translate('Yes') }}</button>
        <button
          type="button"
          id="ePetroBtn_no"
          @click="resetAdditionalParametersValueNo"
          @click.modal="modalShow = !modalShow"
          class="btn btn-ePetro"
          :class="DisableButtonsLabel ? 'displayBtn' :''"
        >{{this.$i18n.translate('No') }}</button>
      </div>
      <br>
    </div>
    <!-- Start additional parameters container -->
    <div>
      <vue-slide-up-down :active="ActiveDropDownPlugin">
        <div class="alert third-container-ePetro" role="alert">
          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="p2O5" class="col-form-label-sm font-weight-bold" >
                1. P<sub>2</sub>O<sub>5</sub> (mg/100g):
              </label>
              <input
                class="form-control input-ePetro"
                :class="{'input': true, 'invalid-input': errors.has('p2o5_vv')}"
                v-model="p2o5_vv"
                name="p2o5_vv"
                v-validate="CropStageFruitValidation ? 'required|decimal:3':'|decimal:3|max_value:1000'"
                id="p2O5"
                :placeholder="placeholder"
                autocomplete="off"
              >
              <span
                v-show="errors.has('p2o5_vv')"
                class="invalid"
              >{{ errors.first('p2o5_vv') }}</span>
            </div>

            <div class="form-group col-md-6">
              <label for="k2O" class="col-form-label-sm font-weight-bold">
                2. K<sub>2</sub>O (mg/100g):
              </label>
              <input
                class="form-control input-ePetro"
                :class="{'input': true, 'invalid-input': errors.has('k2O_vv')}"
                id="k2O"
                v-model="k2O_vv"
                name="k2O_vv"
                v-validate="CropStageFruitValidation ? 'required|decimal:3|max_value:1000':'decimal:3|max_value:1000'"
                :placeholder="placeholder"
                autocomplete="off"
              >
              <span
                v-show="errors.has('k2O_vv')"
                class="invalid"
              >{{ errors.first('k2O_vv') }}</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label for="pH" class="col-form-label-sm font-weight-bold">3. pH:</label>
              <input
                class="form-control input-ePetro"
                :class="{'input': true, 'invalid-input': errors.has('pH_vv') }"
                v-model="pH_vv"
                name="pH_vv"
                v-validate="CropStageFruitValidation ?'required|decimal:3|max_value:14':'decimal:3|max_value:14'"
                id="pH"
                :placeholder="placeholder"
                autocomplete="off"
              >
              <span
                v-show="errors.has('pH_vv')"
                class="invalid"
              >{{ errors.first('pH_vv') }}</span>
            </div>
            <div class="form-group col-md-6">
              <label for="humus" class="col-form-label-sm font-weight-bold">4. {{this.$i18n.translate('Humus') }} (%):</label>
              <input
                class="form-control input-ePetro"
                :class="{'input': true, 'invalid-input': errors.has('humus_vv') }"
                v-model="humus_vv"
                name="humus_vv"
                v-validate="CropStageFruitValidation ? 'required|decimal:3|max_value:100':'decimal:3|max_value:100'"
                id="humus"
                :placeholder="placeholder"
                autocomplete="off"
              >
              <span
                v-show="errors.has('humus_vv')"
                class="invalid"
              >{{ errors.first('humus_vv') }}</span>
            </div>
          </div>

          <div class="form-row">
            <div class="form-group col-md-6">
              <label
                for="tipTla"
                class="col-form-label-sm font-weight-bold"
              >5. {{this.$i18n.translate('SoilType')}}:</label>
              <div class="btn-group btn-group-toggle special" data-toggle="buttons" >
                <label @click="ActiveBtn = 'btn1'" class="btn btn-success" :class="{active: ActiveBtn === 'btn1' }"
                >
                  <input type="radio" name="options" id="option1" value="1" @click="UpdateSoilTypeId">
                  {{this.$i18n.translate('EasySoil')}}
                </label>
                <label
                  @click="ActiveBtn = 'btn2'"
                  class="btn btn-success"
                  :class="{active: ActiveBtn === 'btn2' }"
                >
                  <input  type="radio" name="options" id="option2" value="2" @click="UpdateSoilTypeId">
                  {{this.$i18n.translate('MediumHardSoil')}}
                </label>
                <label
                  @click="ActiveBtn = 'btn3'"
                  class="btn btn-success"
                  :class="{active: ActiveBtn === 'btn3' }"
                >
                  <input
                    type="radio"
                    name="options"
                    id="option3"
                    value="3"
                    @click="UpdateSoilTypeId"
                  >
                  {{this.$i18n.translate('HardSoil')}}
                </label>
              </div>
            </div>
          </div>
          <br>
        </div>
      </vue-slide-up-down>
      <br>
    </div>
    <!-- End additional parameters container -->
  </div>
</template>

<script>

import SOIL_TYPES from '../soilTypes.js'


export default {
  data () {
    return {
      active: false,

      // Vuex communication get/dispatch
      dispatch: this.$store.dispatch,
      get: this.$store.getters,
      modalShow: false
    };
  },
  inject: ["$validator"],
  computed: {
    placeholder () {
      return this.$i18n.translate("PlaceHolderInput");
    },
    CropStageFruitValidation () {
      return this.get.cropStageFruitValidation;
    },
    DisableButtonsLabel () {
      return this.get.disableBtnAdditonal;
    },
    LabelAdditional () {
      return this.get.labelAdditionalParameters;
    },
    ActiveDropDownPlugin: {
      get () {
        return this.get.activeDropDown;
      },
      set (val) {
        this.dispatch("UpdateActiveDropDown", val);
      }
    },
    ActiveBtn: {
      get () {
        return this.get.activeBtn;
      },
      set (val) {
        this.dispatch("UpdateAciveBtn", val);
      }
    },
    k2O_vv: {
      get () {
        return this.get.k2O;
      },
      set (val) {
        this.dispatch("UpdateK2O", parseFloat(val) || null);
      }
    },
    p2o5_vv: {
      get () {
        return this.get.p2O5;
      },
      set (val) {
        this.dispatch("UpdateP2O5", parseFloat(val) || null);
      }
    },
    pH_vv: {
      get () {
        return this.get.ph;
      },
      set (val) {
        this.dispatch("UpdatepH", parseFloat(val) || null);
      }
    },
    humus_vv: {
      get () {
        return this.get.humus;
      },
      set (val) {
        this.dispatch("UpdateHumus", parseFloat(val) || null);
      }
    }
  },
  methods: {
    UpdateSoilTypeId (e) {
      console.log("---CLICKED SOIL---");
      console.info(e.target.value);
      this.dispatch("UpdateSoilTypeId", parseInt(e.target.value));
    },
    resetAdditionalParametersValueNo () {
      this.resetValues();

      // If false, slide up container
      this.$store.dispatch("UpdateActiveDropDown", false);

      // Reset style for button group
      this.dispatch("UpdateAciveBtn", "btn2");
    },
    resetAdditionalParametersValueYes () {
      this.resetValues();
    },
    resetValues () {
      // Reset validate computed values on default values
      this.dispatch("UpdateK2O", null);
      this.dispatch("UpdateP2O5", null);
      this.dispatch("UpdatepH", null);
      this.dispatch("UpdateHumus", null);
      this.dispatch("UpdateSoilTypeId", SOIL_TYPES.MEDIUM_HARD_SOIL);
    }
  }
};
</script>

<style scoped>
.btn-success:not(:disabled):not(.disabled).active,
.btn-success:not(:disabled):not(.disabled):active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #00ae4c;
  border-color: #00ae4c;
}

.invalid-input {
  border: 1px solid #f79483;
  box-shadow: 0 0 0 0.2rem #f7948340;
}

.invalid-input:focus {
  border: 1px solid #f79483;
  box-shadow: 0 0 0 0.2rem #f7948340;
}

.active {
  background-color: #00ae4c;
  border-color: #00ae4c;
}

.invalid {
  color: #f79483;
}

.displayBtn {
  display: none;
}
</style>
